import React, { useEffect, useRef, useState } from "react";
import TitleValueComponent from "../Modules/TitleValueComponent";
import { getWaitingTime } from "../../DashboardAppointmentsView/Helper";

const WaitingTimeComponent = (props) => {
  const { captured_time, appnt } = props;

  let interval = useRef(null);
  const unmounted = useRef(false);
  const [waiting_time, setWaitingTime] = useState();

  // Lifecycle Methods ===>

  useEffect(() => {
    let time = getWaitingTime(captured_time, appnt);
    if (!unmounted.current) {
      setWaitingTime(time);
    }

    interval.current = setInterval(() => {
      if (
        captured_time?.checked_in?.checked_in_time &&
        !captured_time?.consultation_started?.consultation_started_time
      ) {
        time = getWaitingTime(captured_time, appnt);
        if (!unmounted.current) {
          setWaitingTime(time);
        }
      }
    }, 5000);

    return () => {
      unmounted.current = true;
    };
  }, []);

  useEffect(() => {
    if (captured_time?.consultation_started?.consultation_started_time) {
      clearInterval(interval.current);
    }
  }, [captured_time]);

  // <===

  // Create UI ==>

  const displayWaitingTime = () => {
    return <TitleValueComponent title="Waiting Time" value={waiting_time} />;
  };

  // <===

  return <>{displayWaitingTime()}</>;
};

export default WaitingTimeComponent;
